export const commonMessages = {
  error: 'Error',
  success: 'Success',
  warning: 'Warning',
  info: 'Info',
}
